import { registerApplication, start, Application } from 'single-spa';
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from 'single-spa-layout';

import { MODULES_URL } from './constants';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import microfrontendLayout from './layouts/microfrontend.html';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import error404 from './pages/404.html';
import { LayoutEngine } from 'single-spa-layout/dist/types/browser/constructLayoutEngine';
import { setTenantToLocalStorage } from './utils/tenant';
import { initKeycloak } from './utils/initKeycloak';

let startedApplication = false;

async function startAplication() {
  let layoutEngine: LayoutEngine;
  const keycloakInstance = await initKeycloak();
  const token = localStorage.getItem('token');
  const isExpirado = keycloakInstance?.isTokenExpired();

  setTenantToLocalStorage();

  if (!!token && !isExpirado && !startedApplication) {
    try {
      const response = await fetch(MODULES_URL);
      const responseJson = await response.json();
      let htmlRoutes: string = responseJson.modules
        .map((app) => {
          const { name, exact, path, props } = app;

          const exactParam = exact ? `exact="true"` : '';
          const exactProps =
            props && props !== '' && props !== undefined && props !== null
              ? `props="${props}"`
              : '';

          return `<route path="${path}" ${exactParam}>
                  <application  ${exactProps} name="${name}"></application>
                </route>`;
        })
        .join('\n');

      htmlRoutes += `
      <route default>
        ${error404}
      </route>
    `;

      // current route
      const hideSidebar = false;

      const data = {
        props: {
          currentDomain: 'Fulfillment',
          hideSidebar: hideSidebar,
          listItems: ['item1', 'item2'],
          routes: [
            {
              key: 'fulfillment',
              name: 'Fulfillment',
              pathname: '/fulfillment',
              previousPath: '/',
              childrens: [
                {
                  key: 'fulfillment-branch-billing',
                  name: 'Gestão de estoque',
                  pathname: '/fulfillment/gestao-de-estoque',
                  previousPath: '/fulfillment',
                },
                {
                  key: 'fulfillment-branch-billing',
                  name: 'Agendar envio e coleta',
                  pathname: '/fulfillment/agendamento',
                  previousPath: '/fulfillment',
                },
                {
                  key: 'fulfillment-branch-billing',
                  name: 'Filiais de faturamento',
                  pathname: '/fulfillment/filiais-de-faturamento',
                  previousPath: '/fulfillment',
                },
                {
                  key: 'fulfillment-branch-billing',
                  name: 'Importar dados em massa',
                  pathname: '/fulfillment/importar-em-massa',
                  previousPath: '/fulfillment',
                },
                {
                  key: 'fulfillment-product-integration',
                  name: 'Status dos Produtos',
                  pathname: '/fulfillment/status-dos-produtos',
                  previousPath: '/fulfillment',
                },
                {
                  key: 'fulfillment-product-integration-sku-matcher',
                  name: 'Combinar SKUs',
                  pathname: '/fulfillment/combinar-skus',
                  previousPath: '/fulfillment',
                },
              ],
            },
            {
              key: 'financial_management',
              name: 'Financeiro',
              pathname: '/financeiro',
              previousPath: '/',
              childrens: [
                {
                  key: 'financial_management_bill',
                  name: 'Faturas e Extratos',
                  pathname: '/financeiro/faturas-extratos',
                  previousPath: '/financeiro',
                },
                {
                  key: 'financial_management_coparticipation_freight',
                  name: 'Coparticipação de Frete',
                  pathname: '/financeiro/coparticipacao-frete',
                  previousPath: '/financeiro',
                },
              ],
            },
            {
              key: 'self_hiring',
              name: 'Catálogo de serviços',
              pathname: '/catalogo-servicos',
              previousPath: '/',
            },
          ],
        },
        loaders: {},
      };

      const routes = constructRoutes(
        microfrontendLayout.replace('<!--APPS-->', htmlRoutes),
        data,
      );

      const applications = constructApplications({
        routes,
        loadApp({ name }) {
          return System.import<Application>(name);
        },
      });

      layoutEngine = constructLayoutEngine({ routes, applications });

      applications.forEach(registerApplication);
      layoutEngine.activate();
      start();
      startedApplication = true;
    } catch (_error) {
      setTimeout(startAplication, 1000);
    }
  }
}

startAplication();
